<script setup lang="ts">
import { UiIcon, UiText, UiTooltip } from "@shopexperts/shared";
import type { QuoteMessageCardMetric } from "./QuoteMessageCard.types";

defineProps<{
    cards: QuoteMessageCardMetric[];
}>();
</script>

<template>
    <section class="grid gap-4 grid-cols-3 max-sm:flex max-sm:flex-col max-sm:shrink-0 max-sm:gap-0 max-sm:rounded-md max-sm:border max-sm:border-se-gray-300 max-sm:overflow-hidden">
        <div v-for="(card, index) in cards" :key="card.label"
            class="rounded-md border border-se-gray-300 p-4
                max-sm:flex max-sm:items-center max-sm:justify-between max-sm:gap-4 max-sm:py-3 max-sm:px-4
                max-sm:shrink-0 max-sm:rounded-none max-sm:border-0 max-sm:border-t max-sm:border-se-gray-200"
            :class="{ 'max-sm:border-t-0': index === 0 }">
            <UiText as="h6" class="text-se-dark max-sm:hidden">
                {{ card.label }}
            </UiText>
            <div class="flex items-center gap-1 max-sm:hidden">
                <UiText
                    as="p"
                    variant="h4"
                    class="text-se-dark"
                    :class="card.valueIsEstimate ? 'decoration-dashed underline underline-offset-4 decoration-se-gray-500' : ''"
                >
                    {{ card.value }}
                </UiText>
                <UiTooltip v-if="card.detail" :content="card.detail">
                    <UiIcon name="info-circle" class="inline-block h-3.5 w-3.5" />
                </UiTooltip>
            </div>

            <UiText as="span" variant="h6" class="hidden text-se-gray-700 shrink-0 max-sm:inline">
                {{ card.label }}
            </UiText>
            <div class="hidden items-center gap-1 min-w-0 max-sm:inline-flex">
                <UiText
                    as="span"
                    variant="h5"
                    class="font-semibold text-se-dark text-right truncate"
                    :class="card.valueIsEstimate ? 'decoration-dashed underline underline-offset-4 decoration-se-gray-500' : ''"
                >
                    {{ card.value }}
                </UiText>
                <UiTooltip v-if="card.detail" :content="card.detail">
                    <UiIcon name="info-circle" class="inline-block h-3.5 w-3.5 shrink-0" />
                </UiTooltip>
            </div>
        </div>
    </section>
</template>
